import { Alert, Card, Col, Row, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EducationPageChrome from '@/pages/education/components/EducationPageChrome';
import { useAuthStore } from '@/store/authStore';
import { canAccessRouteByPermissions } from '@/config/routePermissions';

export default function UdiseHubPage() {
  const { t } = useTranslation('education');
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const perms = user?.permissions || [];

  const cards = [
    {
      path: '/education/udise/maps',
      title: t('udiseMaps'),
      description: t('udiseMapsIntro'),
    },
    {
      path: '/education/udise/runs',
      title: t('udiseRuns'),
      description: t('udiseRunsIntro'),
    },
  ].filter((c) => canAccessRouteByPermissions(c.path, perms, false));

  return (
    <EducationPageChrome title={t('udise')} description={t('udiseIntro')}>
      <Alert type="info" showIcon style={{ marginBottom: 16 }} message={t('udiseReadinessHint')} />
      <Row gutter={[16, 16]}>
        {cards.map((card) => (
          <Col xs={24} md={12} key={card.path}>
            <Card hoverable onClick={() => navigate(card.path)}>
              <Typography.Title level={5}>{card.title}</Typography.Title>
              <Typography.Paragraph type="secondary">{card.description}</Typography.Paragraph>
            </Card>
          </Col>
        ))}
      </Row>
    </EducationPageChrome>
  );
}
